import {
  PopoverPosition as BlueprintPopoverPosition,
  Pre as BlueprintPre,
} from '@blueprintjs/core';
import { RuleCancelled } from '@carbon/icons-react';
import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { VoiceboxResponseAction } from 'bones/constants/voicebox/message';
import { StaticBadge } from 'bones/design-system/components/badge/StaticBadge';
import { Tooltip } from 'bones/design-system/components/Tooltip';
import { Body } from 'bones/design-system/components/typography/Body';

export interface VoiceboxChatUnverifiedProps {
  action: VoiceboxResponseAction;
}

export const VoiceboxChatUnverified: React.VFC<VoiceboxChatUnverifiedProps> = ({
  action,
}) => {
  const { copy, testIds } = useVoiceboxSchema();

  const externalLlmMetadata: { code: string; codeExplanation: string } =
    React.useMemo(() => {
      try {
        const maybeData = JSON.parse(action.value);
        return {
          code: maybeData?.code || '',
          codeExplanation: maybeData?.code_explanation || '',
        };
      } catch (err) {
        console.warn('Problem loading external llm metadata', err);
        return {
          code: '',
          codeExplanation: '',
        };
      }
    }, [action]);

  return (
    <Tooltip
      popoverClassName="vb-voicebox-chat-unverified-tooltip"
      position={BlueprintPopoverPosition.TOP_RIGHT}
      slot={
        externalLlmMetadata.code || externalLlmMetadata.codeExplanation ? (
          <div>
            {externalLlmMetadata.code ? (
              <BlueprintPre>{externalLlmMetadata.code}</BlueprintPre>
            ) : null}
            {externalLlmMetadata.codeExplanation ? (
              <Body size="md">{externalLlmMetadata.codeExplanation}</Body>
            ) : null}
          </div>
        ) : undefined
      }
      title={copy.message.menu.externalLlm}
    >
      <StaticBadge
        leftIcon={RuleCancelled}
        size="lg"
        testId={testIds.messages.menu.externalLlmMetadata}
        type="error"
        variant="muted"
      >
        {copy.message.unverified.badge}
      </StaticBadge>
    </Tooltip>
  );
};
